import type { ReactNode } from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@paige/ui';

/**
 * Dark or light, two icons under the companies; the one you are in is marked. Nothing chosen
 * yet means the system's colour, and a press sets the other one outright: no "auto" stop, no
 * words (Dustin, 2026-09-20: not its own button in the bar, and no need to read "Dark" on a moon).
 */
export function ThemeRow(): ReactNode {
  const { resolved, setPreference } = useTheme();
  return (
    <div className="profile__theme" role="group" aria-label="Theme">
      <button
        type="button"
        className={resolved === 'light' ? 'is-on' : undefined}
        aria-pressed={resolved === 'light'}
        aria-label="Light theme"
        title="Light"
        onClick={() => setPreference('light')}
      >
        <Sun size={15} />
      </button>
      <button
        type="button"
        className={resolved === 'dark' ? 'is-on' : undefined}
        aria-pressed={resolved === 'dark'}
        aria-label="Dark theme"
        title="Dark"
        onClick={() => setPreference('dark')}
      >
        <Moon size={15} />
      </button>
    </div>
  );
}
